(function () {
  // ============================================================
  // CONFIG — injected by Liquid template (see page.love-biotica.liquid)
  // ============================================================
  var KLAVIYO = (typeof window !== 'undefined' && window.LB_KLAVIYO) || {};
  var A       = (typeof window !== 'undefined' && window.LB_ASSETS)  || {};
  var P       = (typeof window !== 'undefined' && window.LB_PRICES)  || {};
  var L       = (typeof window !== 'undefined' && window.LB_I18N)    || {};
  var U       = L.ui || {};
  function T(key, def){ return (U[key] != null && U[key] !== '') ? U[key] : def; }

  // ============================================================
  // DATA (English default; window.LB_I18N overrides for nl / bg)
  // ============================================================
  var questions = [
    { key: 'focus', eyebrow: 'Question 01', title: 'Where does your ritual begin?', hint: 'Choose the moment that speaks to you.',
      options: [
        { value: 'clarity',   label: 'Morning',   note: 'The morning step.' },
        { value: 'digestion', label: 'Midday',    note: 'The midday step.' },
        { value: 'glow',      label: 'Evening',   note: 'The evening step.' },
        { value: 'all',       label: 'All three', note: 'The complete three-step ritual.' }
      ]},
    { key: 'morning', eyebrow: 'Question 02', title: 'How does your morning usually arrive?', hint: '',
      options: [
        { value: 'slow',   label: 'Slowly, with effort',  note: '' },
        { value: 'foggy',  label: 'Gently, then it lifts', note: '' },
        { value: 'steady', label: 'Steady, mostly',       note: '' },
        { value: 'bright', label: 'Already bright',       note: '' }
      ]},
    { key: 'sleep', eyebrow: 'Question 03', title: 'How do your evenings tend to wind down?', hint: '',
      options: [
        { value: 'restless', label: 'Still busy',      note: '' },
        { value: 'broken',   label: 'On and off',      note: '' },
        { value: 'enough',   label: 'Mostly settled',  note: '' },
        { value: 'deep',     label: 'Calm & easy',     note: '' }
      ]},
    { key: 'digestion', eyebrow: 'Question 04', title: 'How would you describe your daily rhythm?', hint: '',
      options: [
        { value: 'settled',       label: 'Steady & even',  note: '' },
        { value: 'bloated',       label: 'A little uneven', note: '' },
        { value: 'unpredictable', label: 'Unpredictable',  note: '' },
        { value: 'sensitive',     label: 'Easily shifted',  note: '' }
      ]},
    { key: 'energy', eyebrow: 'Question 05', title: 'How does your afternoon usually feel?', hint: '',
      options: [
        { value: 'steady', label: 'Steady to evening', note: '' },
        { value: 'dips',   label: 'A gentle lull',     note: '' },
        { value: 'crash',  label: 'A real lull',       note: '' },
        { value: 'wired',  label: 'Busy but tired',    note: '' }
      ]},
    { key: 'stress', eyebrow: 'Question 06', title: 'When life is full, where do you notice it first?', hint: '',
      options: [
        { value: 'mind',  label: 'In my focus',   note: '' },
        { value: 'gut',   label: 'In my routine', note: '' },
        { value: 'skin',  label: 'In the mirror', note: '' },
        { value: 'sleep', label: 'In my evenings', note: '' }
      ]},
    { key: 'skin', eyebrow: 'Question 07', title: 'What does your self-care lean toward?', hint: '',
      options: [
        { value: 'hydration', label: 'Hydration',   note: '' },
        { value: 'calm',      label: 'Calm & even',  note: '' },
        { value: 'firmness',  label: 'Firmness',     note: '' },
        { value: 'radiance',  label: 'Radiance',     note: '' }
      ]},
    { key: 'diet', eyebrow: 'Question 08', title: 'How would you describe your daily eating?', hint: '',
      options: [
        { value: 'balanced',  label: 'Mostly balanced',    note: '' },
        { value: 'onthego',   label: 'Often on the go',    note: '' },
        { value: 'plantled',  label: 'Plant-led',          note: '' },
        { value: 'irregular', label: 'A little irregular',  note: '' }
      ]},
    { key: 'routine', eyebrow: 'Question 09', title: 'How consistent is your daily ritual today?', hint: 'No wrong answer — only a starting point.',
      options: [
        { value: 'none',       label: 'Starting fresh', note: '' },
        { value: 'occasional', label: 'On and off',     note: '' },
        { value: 'building',   label: 'Building it',     note: '' },
        { value: 'devoted',    label: 'Devoted daily',   note: '' }
      ]},
    { key: 'age', eyebrow: 'Question 10', title: 'Your stage of life?', hint: 'For your formula’s strength, not your file.',
      options: [
        { value: '20s', label: 'Late 20s',     note: '' },
        { value: '30s', label: '30s',          note: '' },
        { value: '40s', label: '40s',          note: '' },
        { value: '50s', label: '50s & beyond', note: '' }
      ]}
  ];
  if (L.questions && L.questions.length) { questions = L.questions; }

  var resultMap = {
    clarity:   { name: 'Neural Balance',            tag: 'Morning ritual',      note: 'Your morning step — taken on waking.',          img: A.neuralBalance,    price: P.neuralBalance    || '€47'  },
    digestion: { name: 'Digestive Harmony',         tag: 'Midday ritual',       note: 'Your midday step — taken with lunch.',          img: A.digestiveHarmony, price: P.digestiveHarmony || '€45'  },
    glow:      { name: 'Beauty Activator',          tag: 'Evening ritual',      note: 'Your evening step — taken before bed.',         img: A.beautyActivator,  price: P.beautyActivator  || '€49'  },
    all:       { name: 'The Biotica Ritual System', tag: 'The complete ritual', note: 'All three steps — your complete daily ritual.', img: A.ritualSystem,     price: P.ritualSystem     || '€127' }
  };
  // Merge translated tag/note (product names stay as brand names).
  if (L.results) {
    for (var rk in resultMap) {
      if (resultMap.hasOwnProperty(rk) && L.results[rk]) {
        if (L.results[rk].tag)  resultMap[rk].tag  = L.results[rk].tag;
        if (L.results[rk].note) resultMap[rk].note = L.results[rk].note;
        if (L.results[rk].name) resultMap[rk].name = L.results[rk].name;
      }
    }
  }

  // ============================================================
  // STATE + DOM REFS
  // ============================================================
  var state = { step: 'intro', answers: { focus:null, morning:null, sleep:null, digestion:null, energy:null, stress:null, skin:null, diet:null, routine:null, age:null, email:'', name:'' } };
  var overlay  = document.getElementById('lb-modal-overlay');
  var pane     = document.getElementById('lb-modal-pane');
  var bar      = document.getElementById('lb-progress-bar');
  var lbl      = document.getElementById('lb-progress-label');
  var lastFocused = null;

  // ============================================================
  // HELPERS
  // ============================================================
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }

  function isValidEmail(email){
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // Klaviyo Client-Side Subscriptions API
  // Docs: https://developers.klaviyo.com/en/reference/create_client_subscription
  function klaviyoSubscribe(email, listId, source, properties, name){
    if (!KLAVIYO.companyId || !listId) {
      return Promise.reject(new Error('Klaviyo not configured. Set window.LB_KLAVIYO in the Liquid template.'));
    }
    var profileAttrs = {
      email: email,
      properties: properties || {}
    };
    if (name) profileAttrs.first_name = name;
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source || 'Love Biotica Landing Page',
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttrs
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO.companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    });
  }

  // ============================================================
  // MODAL FLOW
  // ============================================================
  function open(){
    state = { step: 'intro', answers: { focus:null, morning:null, sleep:null, digestion:null, energy:null, stress:null, skin:null, diet:null, routine:null, age:null, email:'', name:'' } };
    lastFocused = document.activeElement;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    // Kick the modal rail video (muted autoplay) if a video is used.
    var rv = document.querySelector('.modal-rail-video');
    if (rv && rv.play) { rv.muted = true; rv.playsInline = true; var rp = rv.play(); if (rp && rp.catch) rp.catch(function(){}); }
    render();
  }
  function close(){
    overlay.hidden = true;
    document.body.style.overflow = '';
    // Mark as seen so the auto-open timer never re-nags this session.
    // Buttons ([data-open-quiz]) still call open() directly, so they always work.
    try { sessionStorage.setItem('lb_quiz_seen', '1'); } catch (e) {}
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }
  function start(){ state.step = 0; render(); }
  function back(){
    if (state.step === 'result' || state.step === 'success') state.step = questions.length - 1;
    else if (typeof state.step === 'number' && state.step > 0) state.step = state.step - 1;
    else if (state.step === 0) state.step = 'intro';
    render();
  }
  function retake(){
    state = { step: 'intro', answers: { focus:null, morning:null, sleep:null, digestion:null, energy:null, stress:null, skin:null, diet:null, routine:null, age:null, email:'', name:'' } };
    render();
  }
  function pick(key, value){
    state.answers[key] = value;
    render();
    setTimeout(function(){
      if (typeof state.step !== 'number') return;
      state.step = state.step + 1 >= questions.length ? 'result' : state.step + 1;
      render();
    }, 220);
  }

  function progress(){
    var total = questions.length;
    if (state.step === 'intro')                                       return { pct:'0%',   label: T('ready', 'Ready when you are') };
    if (state.step === 'result' || state.step === 'success')          return { pct:'100%', label: T('profileComplete', 'Profile complete') };
    var n = state.step;
    return { pct: Math.round((n/total)*100)+'%', label: T('stepWord','Step') + ' ' + String(n+1).padStart(2,'0') + ' ' + T('ofWord','of') + ' ' + String(total).padStart(2,'0') };
  }

  // ============================================================
  // RENDER
  // ============================================================
  function renderIntro(){
    return ''
      + '<div class="modal-intro">'
      + '  <p class="t-label" style="color:var(--olive);margin:0 0 14px;">' + esc(T('introEyebrow','Begin Here')) + '</p>'
      + '  <h3 class="t-heading t-balance">' + esc(T('introTitle','Find Your Personalized Ritual')) + '</h3>'
      + '  <p class="t-body">' + esc(T('introBody','Answer a few quick questions and discover the right Love Biotica ritual for you.')) + '</p>'
      + '  <ul class="intro-bullets">'
      + '    <li>' + esc(T('introB1','Takes about 3 minutes')) + '</li>'
      + '    <li>' + esc(T('introB2','Ten quiet questions')) + '</li>'
      + '    <li>' + esc(T('introB3','Tailored to your rhythm')) + '</li>'
      + '  </ul>'
      + '  <div style="display:flex;gap:16px;align-items:center;flex-wrap:wrap;">'
      + '    <button class="btn btn-primary" type="button" data-act="start">' + esc(T('startBtn','Start Quiz →')) + '</button>'
      + '    <button class="btn-link" type="button" data-act="close" style="background:transparent;border:0;border-bottom:1px solid var(--ink-soft);padding:4px 0;">' + esc(T('notNow','Not now')) + '</button>'
      + '  </div>'
      + '</div>';
  }

  function renderQuestion(q){
    var sel = state.answers[q.key];
    var opts = q.options.map(function(o){
      var isSel = sel === o.value;
      return ''
        + '<button class="qopt' + (isSel?' is-sel':'') + '" type="button" data-act="pick" data-key="' + esc(q.key) + '" data-value="' + esc(o.value) + '">'
        + '  <span class="qopt-label">'
        + '    <span>' + esc(o.label) + '</span>'
        + (o.note ? '<span class="qopt-note">' + esc(o.note) + '</span>' : '')
        + '  </span>'
        + '  <span class="qopt-dot"></span>'
        + '</button>';
    }).join('');
    return ''
      + '<div style="display:flex;flex-direction:column;flex:1;">'
      + '  <p class="t-label" style="color:var(--olive);margin:0 0 14px;">' + esc(q.eyebrow) + '</p>'
      + '  <h3 class="t-heading t-balance" style="margin:0 0 8px;color:var(--ink);">' + esc(q.title) + '</h3>'
      + (q.hint ? '<p class="t-body t-italic t-mute" style="margin:0 0 22px;">' + esc(q.hint) + '</p>' : '<div style="height:14px;"></div>')
      + '  <div style="display:flex;flex-direction:column;gap:10px;">' + opts + '</div>'
      + '  <div style="margin-top:auto;padding-top:22px;display:flex;justify-content:space-between;align-items:center;">'
      + '    <button class="btn-link" type="button" data-act="back" style="background:transparent;border:0;color:var(--ink-mute);border-bottom:1px solid var(--ink-mute);padding:4px 0;">' + esc(T('back','← Back')) + '</button>'
      + '    <p class="t-label" style="font-size:11px;color:var(--ink-mute);margin:0;">' + esc(T('selectToContinue','Select to continue')) + '</p>'
      + '  </div>'
      + '</div>';
  }

  function renderResult(){
    var r = resultMap[state.answers.focus] || resultMap.all;
    return ''
      + '<div style="display:flex;flex-direction:column;flex:1;">'
      + '  <p class="t-label" style="color:var(--olive);margin:0 0 14px;">' + esc(T('resultEyebrow','Your Ritual')) + '</p>'
      + '  <h3 class="t-heading t-italic" style="margin:0 0 22px;color:var(--ink);">' + esc(T('resultTitle','We made this')) + ' <em style="font-style:normal;">' + esc(T('resultTitleEm','for you.')) + '</em></h3>'
      + '  <div style="display:grid;grid-template-columns:120px 1fr;gap:20px;align-items:center;padding:18px;border:1px solid var(--line);background:var(--cream);margin-bottom:24px;">'
      + '    <div style="aspect-ratio:1/1;overflow:hidden;background:var(--sand);">'
      + '      <img src="' + esc(r.img) + '" alt="' + esc(r.name) + '" style="width:100%;height:100%;object-fit:cover;">'
      + '    </div>'
      + '    <div>'
      + '      <p class="t-label" style="font-size:11px;color:var(--ink-mute);margin:0 0 6px;">' + esc(r.tag) + '</p>'
      + '      <h4 class="t-heading" style="margin:0 0 6px;color:var(--ink);font-size:calc(var(--t-body) + 10px);">' + esc(r.name) + '</h4>'
      + '      <p class="t-body t-italic t-mute" style="margin:0 0 8px;">' + esc(r.note) + '</p>'
      + '      <p style="font-family:var(--font);font-weight:500;font-size:calc(var(--t-body) + 6px);color:var(--gold);margin:0;letter-spacing:0.02em;">' + esc(r.price) + '</p>'
      + '    </div>'
      + '  </div>'
      + '  <p class="t-body t-mute" style="margin:0 0 14px;">' + T('resultLeadHtml', 'Leave your name and email and we’ll send your Wellness Profile, plus <em>The 7-Day Elegant Reset Blueprint</em> — free.') + '</p>'
      + '  <input type="text" id="lb-result-name" placeholder="' + esc(T('namePh','Your name')) + '" value="' + esc(state.answers.name || '') + '" autocomplete="given-name" style="width:100%;padding:14px 16px;border:1px solid var(--line);background:#fff;font-family:var(--font);font-size:15px;color:var(--ink);margin-bottom:10px;">'
      + '  <div class="input-row input-row-light" style="margin-bottom:6px;">'
      + '    <input type="email" id="lb-result-email" placeholder="' + esc(T('emailPh','Your email')) + '" value="' + esc(state.answers.email || '') + '" autocomplete="email">'
      + '    <button type="button" data-act="quiz-submit">' + esc(T('sendBtn','Send →')) + '</button>'
      + '  </div>'
      + '  <p class="form-error" id="lb-result-error" role="alert" aria-live="polite" style="min-height:18px;margin:6px 0 0;"></p>'
      + '  <div style="display:flex;justify-content:space-between;align-items:center;margin-top:14px;">'
      + '    <button class="btn-link" type="button" data-act="back" style="background:transparent;border:0;color:var(--ink-mute);border-bottom:1px solid var(--ink-mute);padding:4px 0;">' + esc(T('back','← Back')) + '</button>'
      + '    <button class="btn-link btn-link-olive" type="button" data-act="retake" style="background:transparent;border:0;border-bottom:1px solid var(--olive);padding:4px 0;">' + esc(T('retake','Retake quiz')) + '</button>'
      + '  </div>'
      + '</div>';
  }

  function renderSuccess(email){
    return ''
      + '<div class="modal-success">'
      + '  <div class="modal-success-icon" aria-hidden="true">'
      + '    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.4"><polyline points="4 11 9 16 18 6"></polyline></svg>'
      + '  </div>'
      + '  <p class="t-label" style="color:var(--olive);margin:0 0 14px;">' + esc(T('successEyebrow','Profile Complete')) + '</p>'
      + '  <h3 class="t-heading t-italic" style="margin:0 0 14px;color:var(--ink);">' + esc(T('successTitle','Your ritual is')) + ' <em style="font-style:normal;">' + esc(T('successTitleEm','on its way.')) + '</em></h3>'
      + '  <p class="t-body t-mute" style="margin:0 0 28px;max-width:38ch;">' + T('successBodyPreHtml','Check your inbox at ') + '<em style="font-style:normal;color:var(--ink);">' + esc(email) + '</em>' + T('successBodyPostHtml',' in the next few minutes for your Wellness Profile and <em>The 7-Day Elegant Reset Blueprint</em>.') + '</p>'
      + '  <button class="btn-link" type="button" data-act="close" style="background:transparent;border:0;border-bottom:1px solid var(--ink-soft);color:var(--ink-soft);padding:4px 0;">' + esc(T('close','Close')) + '</button>'
      + '</div>';
  }

  function render(){
    var p = progress();
    bar.style.width = p.pct;
    lbl.textContent = p.label;
    if      (state.step === 'intro')   pane.innerHTML = renderIntro();
    else if (state.step === 'result')  pane.innerHTML = renderResult();
    else if (state.step === 'success') pane.innerHTML = renderSuccess(state.answers.email);
    else                               pane.innerHTML = renderQuestion(questions[state.step]);

    var nameInput = document.getElementById('lb-result-name');
    if (nameInput) nameInput.addEventListener('input', function(e){ state.answers.name = e.target.value; });
    var emailInput = document.getElementById('lb-result-email');
    if (emailInput) emailInput.addEventListener('input', function(e){ state.answers.email = e.target.value; });

    setTimeout(function(){
      var first = document.querySelector('#lb-quiz-modal button, #lb-quiz-modal input');
      if (first) first.focus();
    }, 30);
  }

  // ============================================================
  // QUIZ EMAIL SUBMIT
  // ============================================================
  function handleQuizSubmit(){
    var nameInput  = document.getElementById('lb-result-name');
    var emailInput = document.getElementById('lb-result-email');
    var errEl      = document.getElementById('lb-result-error');
    var button     = document.querySelector('[data-act="quiz-submit"]');
    if (!nameInput || !emailInput || !button) return;

    var name  = (nameInput.value || '').trim();
    var email = (emailInput.value || '').trim();
    if (!name) {
      if (errEl) errEl.textContent = T('errName','Please enter your name.');
      return;
    }
    if (!isValidEmail(email)) {
      if (errEl) errEl.textContent = T('errEmail','Please enter a valid email address.');
      return;
    }
    if (errEl) errEl.textContent = '';
    button.disabled = true;
    button.textContent = T('sending','Sending…');

    var r = resultMap[state.answers.focus] || resultMap.all;
    var properties = {
      'Quiz Result':        r.name,
      'Quiz Focus':         state.answers.focus,
      'Quiz Morning':       state.answers.morning,
      'Quiz Sleep':         state.answers.sleep,
      'Quiz Digestion':     state.answers.digestion,
      'Quiz Energy':        state.answers.energy,
      'Quiz Stress':        state.answers.stress,
      'Quiz Skin':          state.answers.skin,
      'Quiz Diet':          state.answers.diet,
      'Quiz Routine':       state.answers.routine,
      'Quiz Stage of Life': state.answers.age,
      'Source':             'Love Biotica Wellness Profile Quiz'
    };

    klaviyoSubscribe(email, KLAVIYO.quizListId, 'Wellness Profile Quiz', properties, name)
      .then(function(res){
        if (!res.ok && res.status !== 202) throw new Error('Subscription failed with status ' + res.status);
        state.answers.email = email;
        state.answers.name = name;
        state.step = 'success';
        render();
      })
      .catch(function(err){
        button.disabled = false;
        button.textContent = T('sendBtn','Send →');
        if (errEl) errEl.textContent = T('errGeneric','Something went wrong. Please try again.');
        if (window.console) console.error('Klaviyo subscribe error:', err);
      });
  }

  // ============================================================
  // WAITLIST FORM SUBMIT
  // ============================================================
  function handleWaitlistSubmit(e){
    e.preventDefault();
    var form   = e.currentTarget;
    var input  = form.querySelector('input[type="email"]');
    var button = form.querySelector('button');
    var errEl  = document.getElementById('lb-waitlist-error');
    var email  = (input.value || '').trim();

    if (!isValidEmail(email)) {
      if (errEl) errEl.textContent = T('errEmail','Please enter a valid email address.');
      return;
    }
    if (errEl) errEl.textContent = '';
    button.disabled = true;
    var origText = button.textContent;
    button.textContent = T('joining','Joining…');

    klaviyoSubscribe(email, KLAVIYO.waitlistListId, 'Love Biotica Waitlist', { 'Source': 'Waitlist Section' })
      .then(function(res){
        if (!res.ok && res.status !== 202) throw new Error('Subscription failed with status ' + res.status);
        var success = document.createElement('div');
        success.className = 'form-success';
        success.innerHTML = T('waitlistSuccessHtml', "You’re on the list. Look out for <em>The 7-Day Elegant Reset Blueprint</em> in your inbox shortly.");
        form.parentNode.replaceChild(success, form);
        if (errEl && errEl.parentNode) errEl.parentNode.removeChild(errEl);
      })
      .catch(function(err){
        button.disabled = false;
        button.textContent = origText;
        if (errEl) errEl.textContent = T('errGeneric','Something went wrong. Please try again.');
        if (window.console) console.error('Klaviyo subscribe error:', err);
      });
  }

  // ============================================================
  // EVENT WIRING
  // ============================================================
  document.addEventListener('click', function(e){
    var openTrigger = e.target.closest('[data-open-quiz]');
    if (openTrigger) { e.preventDefault(); open(); return; }
    if (e.target === overlay) { close(); return; }
    var act = e.target.closest('[data-act]');
    if (!act || !overlay.contains(act)) return;
    var a = act.getAttribute('data-act');
    if (a === 'start')       start();
    if (a === 'close')       close();
    if (a === 'back')        back();
    if (a === 'retake')      retake();
    if (a === 'pick')        pick(act.getAttribute('data-key'), act.getAttribute('data-value'));
    if (a === 'quiz-submit') handleQuizSubmit();
  });
  document.getElementById('lb-modal-close').addEventListener('click', close);
  document.addEventListener('keydown', function(e){
    if (overlay.hidden) return;
    if (e.key === 'Escape') close();
  });

  // Waitlist form
  var waitlistForm = document.getElementById('lb-waitlist-form');
  if (waitlistForm) waitlistForm.addEventListener('submit', handleWaitlistSubmit);

  // Ensure waitlist video autoplays
  var v = document.querySelector('.waitlist-video');
  if (v) { v.muted = true; v.playsInline = true; var p = v.play(); if (p && p.catch) p.catch(function(){}); }

  // ============================================================
  // LEGACY SLIDER — auto cross-fade every 2s (Heritage section)
  // ============================================================
  (function(){
    var slider = document.querySelector('[data-legacy-slider]');
    if (!slider) return;
    var slides = slider.querySelectorAll('.legacy-slide');
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function(){
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 2000);
  })();

  // ============================================================
  // AUTO-OPEN QUIZ — 5s after load, once per browser session.
  // ============================================================
  function lbAutoOpen(){
    try { if (sessionStorage.getItem('lb_quiz_seen')) return; } catch (e) {}
    try { sessionStorage.setItem('lb_quiz_seen', '1'); } catch (e) {}
    if (overlay && overlay.hidden) open();
  }
  setTimeout(lbAutoOpen, 5000);
})();
